import React from 'react';

const MarketingPopupStaticContent = ({ campaign }) => {
  return (
    <div className='marketing-popup__static-content'>
      {campaign.imageUrl && (
        <img
          src={campaign.imageUrl}
          alt={campaign.title}
          className='marketing-popup__static-image'
        />
      )}
      {campaign.description && (
        <p className='marketing-popup__static-description'>
          {campaign.description}
        </p>
      )}
      {campaign.ctaUrl && (
        <a
          href={campaign.ctaUrl}
          target='_blank'
          rel='noopener noreferrer'
          className='marketing-popup__static-cta'
        >
          {campaign.ctaText || 'Learn More'}
        </a>
      )}
    </div>
  );
};

export default MarketingPopupStaticContent;
